/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Y_Move_UpInputs */

const en_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move Up 1 Line`)
};

const fr_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déplacer Vers le Haut de 1 Ligne`)
};

const de_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Zeile nach oben rücken`)
};

const it_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spostati di 1 riga in su`)
};

const ru_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переместиться на 1 строку вверх`)
};

const es_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir 1 línea`)
};

const zh_cn2_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`向上移动一行`)
};

const ja_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1行上に移動`)
};

const hi_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक पंक्ति ऊपर जाएं`)
};

const pt_pt2_input_position_y_move_up = /** @type {(inputs: Input_Position_Y_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subir uma linha`)
};

/**
* | output |
* | --- |
* | "Move Up 1 Line" |
*
* @param {Input_Position_Y_Move_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_move_up = /** @type {((inputs?: Input_Position_Y_Move_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_Move_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_y_move_up(inputs)
	if (locale === "de") return de_input_position_y_move_up(inputs)
	if (locale === "it") return it_input_position_y_move_up(inputs)
	if (locale === "ru") return ru_input_position_y_move_up(inputs)
	if (locale === "es") return es_input_position_y_move_up(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_y_move_up(inputs)
	if (locale === "ja") return ja_input_position_y_move_up(inputs)
	if (locale === "hi") return hi_input_position_y_move_up(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_y_move_up(inputs)
	return en_input_position_y_move_up(inputs)
});